import {IconProps} from './types';

const ThumbUp = ({fill = 'currentColor', className, width = 20, height = 20}: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 20 20"
        className={className}
    >
        <path
            fill={fill}
            stroke={fill}
            d="m9.667 2.72-.001-.012a1.17 1.17 0 0 1 .989-1.213c.276-.036.601.028.913.272s.64.697.865 1.478a6.7 6.7 0 0 1-.259 2.976l-.147.411a.7.7 0 0 0-.052.196l-.005.08.005.08c.01.08.032.16.068.232l.013.027.016.024a.69.69 0 0 0 .587.31v.002h5.257a1.59 1.59 0 0 1 1.463.978c.08.192.12.398.12.605v.008l.002.008a1.58 1.58 0 0 1-.753 1.392l-.4.244.218.415a1.385 1.385 0 0 1-.612 1.885l-.45.221.223.45c.093.188.141.396.14.607v.003a1.38 1.38 0 0 1-.752 1.222l-.44.224.218.444c.093.188.142.396.14.607v.004c0 .223-.044.442-.188.605-.134.152-.442.353-1.186.353h-5.421a13.7 13.7 0 0 1-3.305-.378l-.009-.002-.01-.002-.764-.153v-8.32c.833-.603 1.7-1.55 2.361-2.636.667-1.095 1.156-2.378 1.156-3.634zM.833 8.65h2.709a.333.333 0 0 1 .333.333v9.167a.333.333 0 0 1-.333.333H.833A.333.333 0 0 1 .5 18.15V8.983a.333.333 0 0 1 .333-.333ZM2.5 15.567a1.126 1.126 0 0 0-1.1 1.361 1.126 1.126 0 0 0 2.225-.281 1.126 1.126 0 0 0-1.125-1.08Z"
        />
    </svg>
);

export default ThumbUp;
